export default __webpack_public_path__ + "static/media/japan.382df14f.svg";